/**
 * 前端全局常量（与业务/环境无关的配置）
 * 路由、功能开关等可集中在此，便于维护与文档化
 */

/** 站点标题后缀，与 router beforeEach 中 document.title 拼接一致 */
export const SITE_TITLE_SUFFIX = 'SKILLITH-EDU'

/** 管理员隐藏入口 query 键名 */
export const ADMIN_ENTRANCE_QUERY_KEY = 'k'

/**
 * 管理员隐藏入口口令（仅用于“隐藏入口”用途，真正安全依赖后端鉴权）
 * 如需更换，与 router 中 ADMIN_ENTRANCE_KEY 保持同步，或改为从环境变量读取
 */
export const ADMIN_ENTRANCE_KEY = 'k9V-7xQp_3mN~Z2sR8aC1dF6gH0jL4tU'

/** 不展示主布局（全屏）的认证相关路径 */
export const AUTH_PAGE_PATHS = ['/login', '/forgot-password', '/register']
